import React from 'react';
import { Modal, Typography } from 'antd';

const { Text, Title } = Typography;

const SessionModal = ({ visible, onClose }) => {

    return (
        <Modal
            title="Politique de session"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={520}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <Title level={5} style={{ margin: 0 }}>
                    Déconnexion automatique après inactivité
                </Title>
                <Text style={{ color: '#595959', lineHeight: 1.7 }}>
                    La durée de session est désormais fixe pour tous les utilisateurs afin de renforcer la sécurité et d'uniformiser l'expérience.
                </Text>
                <div
                    style={{
                        background: '#fafafa',
                        border: '1px solid #f0f0f0',
                        borderRadius: 12,
                        padding: '14px 16px',
                        lineHeight: 1.8,
                    }}
                >
                    <div><strong>25 minutes</strong> d'inactivité : affichage d'une alerte.</div>
                    <div><strong>5 minutes supplémentaires</strong> : délai pour continuer la session.</div>
                    <div><strong>30 minutes au total</strong> : déconnexion automatique si aucune action n'est confirmée.</div>
                </div>
                <Text style={{ color: '#8c8c8c' }}>
                    Lors de l'alerte, vous pouvez choisir de continuer la session ou de vous déconnecter immédiatement.
                </Text>
            </div>
        </Modal>
    );
};

export default SessionModal;
